module.exports = __webpack_public_path__ + "img/4.ada9a305.png";